import React, { HTMLProps } from 'react';
import classNames from 'classnames';

const AttachmentContent: React.FC<HTMLProps<HTMLParagraphElement>> = ({ className, ...rest }) => (
    <p className={classNames('nhsuk-attachment__metadata', className)} {...rest} />
);

export default AttachmentContent;